module.exports = __webpack_public_path__ + "static/img/regulacni_ventil_2_prirubovy.7619340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/regulacni_ventil_2_prirubovy.png
// module id = KerA
// module chunks = 1